var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-placeholder",on:{"click":_vm.onClick}},[_c('typography',{staticClass:"card-placeholder__text",attrs:{"bold":"","no-margin":""}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }